import { render, staticRenderFns } from "./UmsApplicationHistory.vue?vue&type=template&id=2d24d5cc&"
import script from "./UmsApplicationHistory.vue?vue&type=script&lang=js&"
export * from "./UmsApplicationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports